export const dropBoolean = [
  { value: 'SIM', label: 'SIM' },
  { value: 'NAO', label: 'NÃO' },
];

export const dropTipoEndereco = [
  { value: 'POSICAO', label: 'POSIÇÃO' },
  { value: 'EQUIPAMENTO', label: 'EQUIPAMENTO' },
  { value: 'DOCA', label: 'DOCA' },
  { value: 'PBR', label: 'PBR' },
  { value: 'ENVELOPE-M', label: 'ENVELOPE-M' },
];
